document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const sliderWraps = document.querySelectorAll('.slider-wrap');
    
    sliderWraps.forEach(function(sliderWrap) {
      const sliderBtn = sliderWrap.querySelector('.slider-btn');
      const beforeWrap = sliderWrap.querySelector('.before-img');
      
      if (sliderBtn && beforeWrap) {
        function limitSliderMovement() {
          const containerWidth = sliderWrap.offsetWidth;
          const btnLeft = parseFloat(sliderBtn.style.left) || 0;
          const btnWidth = sliderBtn.offsetWidth || 2;
          
          const minLeft = 0;
          const maxLeft = containerWidth - btnWidth;
          
          let newLeft = Math.max(minLeft, Math.min(maxLeft, btnLeft));
          
          sliderBtn.style.left = newLeft + 'px';
          beforeWrap.style.width = newLeft + 'px';
        }
      
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
              requestAnimationFrame(limitSliderMovement);
            }
          });
        });
        
        observer.observe(sliderBtn, {
          attributes: true,
          attributeFilter: ['style']
        });
        
        observer.observe(beforeWrap, {
          attributes: true,
          attributeFilter: ['style']
        });
        
        function centerSlider() {
          const containerWidth = sliderWrap.offsetWidth;
          const btnWidth = sliderBtn.offsetWidth || 2;
          const centerPosition = (containerWidth - btnWidth) / 2;
          
          sliderBtn.style.left = centerPosition + 'px';
          beforeWrap.style.width = centerPosition + 'px';
        }
        
        centerSlider();
       
        limitSliderMovement();
      }
    });
  }, 1500);
}); 